import React from 'react';

export default function LeadsTableStyles()
{
  return (
    <style>{`
      .table100 {
        overflow-x: hidden !important;
        margin: 0 auto;
        padding-top: 0px;
      }
      .table100-head {
        width: auto;
        position: relative;
      }
      .table100.ver1 th {
        font-size: 13px;
      }
      .table100.ver1 td {
        font-size: 13px;
      }
      .table100-body {
        width: auto;
        min-height: 800px;
        max-height: calc(100vh - 100px);
        margin-top: 3px;
        overflow: auto;
        overflow-x: hidden !important;
      }
      .table100-body td {
        padding-block: 18px;
      }
      .column1 {
        padding-left: 16px;
      }
      .table100.ver1 .table100-body tr {
        margin: 15px;
      }
      .table100 .table100-head tr {
        margin: 0 15px;
      }
      .leads-edit-btn {
        background: #0072C6;
        color: #fff;
        border: none;
        border-radius: 8px;
        padding: 10px 20px;
        font-size: 16px;
        font-family: "'Open Sans', sans-serif";
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s;
      }
      .leads-edit-btn:hover {
        background: #005A9E;
      }
      .leads-delete-btn {
        background: #dc3545;
        color: #fff;
        border: none;
        border-radius: 8px;
        padding: 10px 20px;
        font-size: 16px;
        font-family: "'Open Sans', sans-serif";
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s;
      }
      .leads-delete-btn:hover {
        background: #a71d2a;
      }
      .leads-modal-form {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 8px 32px rgba(60,60,60,0.18);
        padding: 0;
      }
      .leads-modal-form .modal-body {
        padding: 32px 24px 24px 24px !important;
        border-radius: 0 0 16px 16px;
      }
      .leads-modal-form .modal-header {
        padding: 18px 24px 12px 24px !important;
        background: var(--dashboard-main-color);
        color: var(--white-color);
        border-radius: 16px 16px 0 0;
        border-bottom: 1px solid #f0f0f0;
      }
      .leads-modal-form label {
        font-size: 14px;
        font-weight: 500;
        color: #222;
      }
      .leads-modal-form input {
        margin-top: 4px;
        margin-bottom: 12px;
        border: 1px solid #e0e0e0;
        border-radius: 6px;
        font-size: 15px;
        padding: 8px 12px;
        width: 100%;
        background: #fafbfc;
        transition: border 0.2s;
      }
      .leads-modal-form input:focus {
        border: 1.5px solid var(--dashboard-main-color);
        outline: none;
        background: #fff;
      }
      .leads-modal-form .flex.space-x-3 {
        gap: 12px;
        margin-top: 18px;
      }
      @media (max-width: 600px) {
        .leads-modal-form .modal-body {
          padding: 18px 8px 16px 8px !important;
        }
        .leads-modal-form .flex.space-x-3 {
          flex-direction: column;
          gap: 8px;
        }
        .leads-modal-form button {
          width: 100%;
        }
      }
      
      /* Empty state animations */
      
      .empty-state-container {
        transition: all 0.3s ease;
      }
    `}</style>
  );
}
